import client from '../client'

export const getConversationKey = `${process.env.NEXT_PUBLIC_CHAT_DOMAIN}/api/Chat/GetConversation`

export async function getConversation({ userId, vehicleId, returnVerifiedDealer }) {
  const params = new URLSearchParams({
    withUserId: userId,
    returnVerifiedDealer: returnVerifiedDealer,
  })

  if (vehicleId) {
    params.append('vehicleId', vehicleId)
  }

  return client(`${getConversationKey}?${params}`)
}
